<!--
 * @Author: cryi.liu
 * @Date: 2020-06-16 15:32:24
 * @LastEditTime: 2020-06-21 12:40:22
 * @Description: 阅卷页面
-->
<template>
  <div v-if="loaded" class="content">
    <div class="content-left">
      <question-list
        :question-index="currentQuestionIndex"
        @change-question="changeQuestionHandler" />
    </div>
    <div class="content-right">
      <question-info :question-index="currentQuestionIndex" />
      <mark-content
        :question-index="currentQuestionIndex"
        :data="tableContent"
        :page="page"
        :total="total"
        @index-change="pageIndexChangeHandler" />
      <action-bar
        :question-index="currentQuestionIndex"
        @save="saveHandler"
        @prev="prevHandler"
        @next="nextHandler"
        @save-and-close="saveAndCloseHandler" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import { debounce } from '../../../../utils';
import QuestionList from './components/QuestionList.vue';
import QuestionInfo from './components/QuestionInfo.vue';
import MarkContent from './components/MarkContent.vue';
import ActionBar from './components/ActionBar.vue';

const breadcrumb = [
  { text: '统考中心', href: '/tr/portal/index.jsp' },
  { text: '阅卷' },
];

export default {
  name: 'ExamAnswerMark',
  components: {
    QuestionList,
    QuestionInfo,
    MarkContent,
    ActionBar,
  },
  props: {
    examId: { type: [Number, String], required: true },
  },
  data() {
    return {
      loaded: false,
      currentQuestionIndex: 0,
      tableContent: [],
      page: {
        index: 1,
        size: 10,
        count: 0,
      },
      total: 0,
    };
  },
  computed: {
    ...mapGetters({
      questionList: 'answerMarkStore/questionList',
      markUserAtQuestion: 'answerMarkStore/markUserAtQuestion',
    }),
    libraryId() {
      return this.questionList[this.currentQuestionIndex].libraryId;
    },
    paperIds() {
      return this.questionList[this.currentQuestionIndex].paperIds;
    },
    hasEdit() {
      const tempMarkUser = JSON.parse(JSON.stringify(this.markUserAtQuestion));
      Object.keys(tempMarkUser).forEach((key) => {
        if (tempMarkUser[key] === null) {
          delete tempMarkUser[key];
        }
      });

      return Object.keys(tempMarkUser).length > 0;
    },
  },
  watch: {
    examId: {
      immediate: true,
      handler() {
        this.concurrentRequestThisPageData();
      },
    },
  },
  methods: {
    ...mapActions({
      setBreadcrumb: 'pageStore/invokeSetBreadcrumb',
      setProcessingShowState: 'pageStore/invokeSetProcessingShowState',
      setQuestionList: 'answerMarkStore/invokeSetQuestionList',
      setMarkUserAtQuestion: 'answerMarkStore/invokeSetMarkUserAtQuestion',
    }),
    /**
     * 保存阅卷信息处理函数
     */
    saveHandler() {
      this.setProcessingShowState({ show: true });

      this.requestSaveMarkScoreAndSetting();
    },
    /**
     * 切换上一题处理函数
     */
    prevHandler() {
      this.setProcessingShowState({ show: true });

      this.currentQuestionIndex -= 1;
      this.page.index = 1;

      this.requestUserAnswerListAndSetting();
    },
    /**
     * 切换下一题处理函数
     */
    nextHandler() {
      this.setProcessingShowState({ show: true });

      this.currentQuestionIndex += 1;
      this.page.index = 1;

      this.requestUserAnswerListAndSetting();
    },
    /**
     * 保阅卷信息并关闭处理函数
     */
    saveAndCloseHandler() {
      this.setProcessingShowState({ show: true });

      this.requestSaveMarkScoreAndSetting(true);
    },
    /**
     *  阅卷更改题目处理函数
     */
    changeQuestionHandler(index) {
      this.setProcessingShowState({ show: true });

      this.currentQuestionIndex = index;
      this.page.index = 1;

      this.requestUserAnswerListAndSetting();
    },
    /**
     * 分页索引改变处理函数
     */
    pageIndexChangeHandler(index) {
      this.setProcessingShowState({ show: true });

      this.page.index = index;

      this.requestUserAnswerListAndSetting();
    },
    /**
     * 并发请求次页面首屏所需数据
     */
    concurrentRequestThisPageData() {
      const params = {
        examId: this.examId,
      };

      axios.all([
        this.$http.answer.markQuestionList(params),
      ])
        .then(axios.spread((questionList) => {
          if (questionList.code === '200') {
            if (questionList.data.length === 0) {
              alert('当前没有可阅卷题目！');

              const a = document.createElement('a');

              a.href = '/mvc/page?loc=exam/marking/marklist&smId=4005';

              a.click();

              this.setProcessingShowState({ show: false });
            } else {
              this.setQuestionList({ questionList: questionList.data });

              this.requestUserAnswerListAndSetting();
            }
          } else {
            alert(questionList.msg);
          }
        }))
        .catch(() => {
          alert('获取数据失败！');
        });
    },
    /**
     * 请求题目用户答题列表并设置
     */
    requestUserAnswerListAndSetting: debounce(function () {
      this.requestUserAnswerList()
        .then((result) => {
          /**
           * 后台如果没数据直接不返回字段
           * 做容错
           */
          if (!result.content) {
            result.content = [];
          }

          if (!result.count) {
            result.count = 0;
          }

          if (!result.pageCount) {
            result.pageCount = 0;
          }

          const tempTableContent = JSON.parse(JSON.stringify(result.content));

          tempTableContent.forEach((user) => {
            if (this.markUserAtQuestion[user.id]) {
              user.userScore = this.markUserAtQuestion[user.id];
            }
          });

          this.tableContent = tempTableContent;
          this.total = result.count;
          this.page.count = result.pageCount;
          this.page.index = result.pageIndex;

          this.loaded = true;
          this.setProcessingShowState({ show: false });
        })
        .catch((result) => {
          alert(result.msg);

          this.loaded = true;
          this.setProcessingShowState({ show: false });
        });
    }, 500),
    /**
     * 请求题目用户答题列表
     */
    requestUserAnswerList() {
      const params = {
        libraryId: this.libraryId,
        paperIds: this.paperIds,
        pageNumber: this.page.index,
        pageSize: this.page.size,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.answer.markUserList(params);

        if (result.code === '200') {
          resolve(result.data);
        } else {
          reject(result);
        }
      });
    },
    /**
     * 请求保存阅卷分数并设置
     */
    requestSaveMarkScoreAndSetting(close = false) {
      this.requestSaveMarkScore()
        .then(() => {
          this.setMarkUserAtQuestion({ markUserAtQuestion: {} });

          if (!close) {
            this.page.index = 1;
            this.requestUserAnswerListAndSetting();
          } else {
            // eslint-disable-next-line no-lonely-if
            if (window.confirm('确认关闭窗口？')) {
              this.setProcessingShowState({ show: false });

              const a = document.createElement('a');

              a.href = '/mvc/page?loc=exam/marking/marklist&smId=4005';

              a.click();
            } else {
              this.page.index = 1;
              this.requestUserAnswerListAndSetting();
            }
          }
        })
        .catch((result) => {
          alert(result.msg);

          this.setProcessingShowState({ show: false });
        });
    },
    /**
     * 请求保存阅卷分数
     */
    requestSaveMarkScore() {
      const params = [];
      const keys = Object.keys(this.markUserAtQuestion);

      keys.forEach((key) => {
        if (this.markUserAtQuestion[key] !== null) {
          params.push({ id: key, userScore: this.markUserAtQuestion[key] });
        }
      });

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.answer.markSaveScore(params);

        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
  },
  created() {
    this.setBreadcrumb({ breadcrumb });

    this.setProcessingShowState({ show: true });
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasEdit) {
      if (window.confirm('当前有阅卷未保存，确认离开？')) {
        next();
      }
    }
  },
};
</script>

<style lang="less" scoped>
.content {
  display: flex;
  width: calc(100% - 40px);
  margin: 10px 20px;
  margin-bottom: 0;

  & > div:first-of-type {
    margin-right: 20px;
  }

  &-left {
    flex: 0 0 16%;
  }

  &-right {
    flex: 0 0 calc(84% - 20px);

    > div {
      margin-bottom: 12px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}
</style>
